import ConfirmationModal from 'components/ui/ConfirmationModal/confirmation-modal';
import Container from 'components/ui/Container';
import CustomSelect from 'components/ui/Editor/CustomSelect';
import PrimaryButton from 'components/ui/PrimaryButton';
import useToggle from 'hooks/useToggle';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { IRoutineDetail, useDeleteRoutineMutation } from 'redux/reducers/routine';

import RoutineManagementTable from './RoutineManagementTable';
import { useListTrainingQuery } from 'redux/reducers/training';
import download from 'utils/downloadFile';
import SecondaryButton from 'components/ui/SecondaryButton';
import Modal from 'components/ui/Modal/modal';
import { ActionType } from 'utils/action.type.enum';
import { ModuleCode } from 'utils/module.code.enum';

const Routines = () => {
  const timerRef = React.useRef<NodeJS.Timeout>();
  let navigate = useNavigate();

  const [deleteModal, toggleDeleteModal] = useToggle(false);
  const [showQuery, setShowQuery] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const [deletingRoutineState, setDeletingRoutines] = useState<IRoutineDetail | null>(null);

  const [deleteRoutine, { isLoading: isDeleting }] = useDeleteRoutineMutation();
  const { data: trainingData, isLoading } = useListTrainingQuery();

  const [training, setTraining] = useState('');

  // const TrainingList = trainingData?.map((item: any) => {
  //   return {
  //     value: item.id,
  //     label: item.training_name
  //   };
  // });
  const tData = Array.isArray(trainingData?.data) ? trainingData.data : [];

  const TrainingList = tData.map((item: any) => ({
    value: item.id,
    label: item.training_name
  }));

  const [routineStatusValue, setRoutineStatusValue] = useState('');
  const RoutineStatusList = [
    {
      value: 'Running',
      label: 'Running'
    },
    {
      value: 'Completed',
      label: 'Completed'
    },
    {
      value: 'Upcoming',
      label: 'Upcoming'
    }
  ];

  const onViewClicked = (routine_master_id: number) => {
    navigate(`/routine-management/view/${routine_master_id}`);
  };

  const onEditClicked = (routine_master_id: number) => {
    navigate(`/routine-management/edit/${routine_master_id}`);
  };

  const onDeleteConfirm = () => {
    deletingRoutineState &&
      deleteRoutine(deletingRoutineState?.routine_master_id)
        .unwrap()
        .then((data: any) => {
          toast.success('Deleted Successfully');

          toggleDeleteModal();
        })
        .catch((err: any) => {
          toast.error('Error');
        });
  };

  const onDeleteClicked = (data: IRoutineDetail) => {
    setDeletingRoutines(data);
    toggleDeleteModal();
  };
  const [showReprotModal, setshowReprotModal] = useState<boolean>(false);

  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const handleGenerate = () => {
    try {
      download(
        `reports/custom-summary?startDate=${startDate || ''}&endDate=${endDate || ''}`,
        'Report.pdf'
      );
    } catch (err: any) {
      toast.error('Failed to generate');
    }
  };

  return (
    <Container title="Routine">
      {showReprotModal && (
        <Modal
          modalSize="modal-md"
          title={'Generate Report'}
          isModalOpen={showReprotModal}
          closeModal={() => {
            setshowReprotModal(!showReprotModal);
          }}
          renderFooter={() => (
            <div className="hstack gap-2 justify-content-end">
              <SecondaryButton
                title="Close"
                isLoading={false}
                onClick={() => setshowReprotModal(!showReprotModal)}
              />
              <PrimaryButton
                title={'Generate'}
                iconName="ri-add-line align-bottom me-1"
                type="button"
                onClick={() => {
                  handleGenerate();
                }}
              />
            </div>
          )}>
          <div className="d-flex gap-2">
            <div>
              <label>Start Date</label>
              <input
                className="form-control"
                name="startDate"
                type="date"
                onChange={(e: any) => {
                  setStartDate(e.target.value);
                }}
                value={startDate}
              />
            </div>
            <div>
              <label>End Date</label>

              <input
                className="form-control"
                name="endDate"
                type="date"
                onChange={(e: any) => {
                  setEndDate(e.target.value);
                }}
                value={endDate}
              />
            </div>
          </div>
        </Modal>
      )}
      <ConfirmationModal
        isOpen={deleteModal}
        onClose={toggleDeleteModal}
        onConfirm={onDeleteConfirm}
        title="Delete Confirmations"
        isLoading={isDeleting}>
        <>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure ?</h4>
            <p className="text-muted ">You want to Remove this Record ?</p>
          </div>
        </>
      </ConfirmationModal>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-end',
          justifyContent: 'space-between'
        }}>
        <div
          className="d-flex flex-1 justify-space-between"
          style={{
            gap: '16px'
          }}>
          <PrimaryButton
          actionType={ActionType.CAN_ADD}
          module_code={ModuleCode.ROUTINE_MANAGEMENT}
            title={'Create Routine'}
            iconName="ri-add-line align-bottom"
            onClick={() => {
              navigate('/routine-management/create');
            }}
            type="button"
          />

          <div
            style={{
              width: '200px'
            }}>
            <CustomSelect
              name="status"
              options={RoutineStatusList}
              placeholder={'Status'}
              value={routineStatusValue}
              onChange={(e: any) => {
                setRoutineStatusValue(e);
              }}
              containerClassName="w-100"
            />
          </div>

          <div
            style={{
              width: '200px'
            }}>
            <CustomSelect
              name="trainingname"
              options={TrainingList}
              placeholder={'Training Name'}
              value={training}
              onChange={(e: any) => {
                setTraining(e);
              }}
              containerClassName="w-100"
            />
          </div>
          <PrimaryButton
            title={' Report'}
            iconName="ri-add-line align-bottom"
            onClick={() => {
              setshowReprotModal(!showReprotModal);
            }}
            type="button"
          />
        </div>

        <div className="search-box ms-2">
          <input
            type="text"
            className="form-control search"
            placeholder="Search..."
            name="key"
            value={showQuery}
            onChange={(e) => {
              setShowQuery(e.target.value);
              clearTimeout(timerRef.current);
              timerRef.current = setTimeout(() => {
                setSearchQuery(e.target.value);
              }, 2000);
            }}
          />
          <i className="ri-search-line search-icon" />
        </div>
      </div>

      <RoutineManagementTable
        onViewClicked={onViewClicked}
        onEditClicked={onEditClicked}
        onDeleteClicked={onDeleteClicked}
        routineStatusValue={routineStatusValue}
        training={training}
        searchQuery={searchQuery}
      />
    </Container>
  );
};

export default Routines;
